import { useEffect, useState } from "react";
import DriverColours, { DriversInitials } from "./driverColours";

// Defining the types of analysis the user can do for AI
export const aiAnalysisTypes = [
  "race-analysis",
  "gear-figure",
  "lap-time-comparison",
];

const makePromptRequest = ({ prompt }) => {
  // Make a GPT request using the prompt provided
};

// Checking if the user has enetered anything in the personal prompt box
const hasUserEnteredAnything = (inputText) => {
  if (inputText) {
    return true;
  } else {
    return false;
  }
};

export const RaceAnalysis = ({
  raceResult,
  setDoAllInputsExist,
  promptInputError,
  setPromptInputError,
  setChatGPTResponse
}) => {
  const [raceAnalysisPrompt, setRaceAnalysisPrompt] = useState("");
  const [prompt1, setPrompt1] = useState('')
  const [prompt2, setPrompt2] = useState('')
  const [userRequest, setUserRequest] = useState(''); 


  console.log(JSON.stringify({raceResult}))

  // API call for generating the prompts when the race result changes
  useEffect(() => {
      fetch (`${process.env.REACT_APP_BACKEND_URL}/api/coach/get-prompts`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              raceResult: raceResult
          })
      })
      .then((res) => res.json())
      .then((res) => {
          setPrompt1(res.message.prompt1)
          setPrompt2(res.message.prompt2)
      })
    .catch((error) => console.error(error))
  }, [raceResult])


  useEffect(() => {
    fetch (`${process.env.REACT_APP_BACKEND_URL}/api/coach/pre-made-prompt-request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        raceResult: raceResult,
        userRequest: userRequest
      })
    })
    .then((res) => res.json())
    .then((res) => {
      setChatGPTResponse(res.message)
    })
    .catch((error) => console.error(error))
  }, [userRequest])



  const createResultsTable = ({ raceResult }) => {
    return (
      <table>
        <tr>
          <th>Position</th>
          <th>Driver Number</th>
          <th>Driver</th>
          <th>Constructor</th>
          <th>Laps</th>
          <th>Time</th>
        </tr>
        <tbody>
          {raceResult.map((driver) => (
            <tr key={driver.number}>
              <td className="driver-position">{driver.position}</td>
              <td className="driver-number">{driver.number}</td>
              <td
                className="driver-name"
                style={{
                  color: DriversInitials.includes(driver.code)
                    ? DriverColours[DriversInitials.indexOf(driver.code)]
                    : "white",
                }}
              >
                {driver.name}
              </td>
              <td className="driver-team">{driver.team}</td>
              <td className="driver-laps">{driver.laps}</td>
              <td className="driver-time">{driver.time}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="race-analysis-container">
      <div className="results-container">
        {/* Mapping through the results to create a table */}
        {createResultsTable({ raceResult })}
      </div>

      <div className="prompt-container">
        <ul
          className={
            raceAnalysisPrompt === 3 ? "prompt-list-hidden" : "prompt-list"
          }
        >
          {/* If the prompt is set to the personal one, hide the other pre-made prompts */}
          <li
            onClick={() => {
              setRaceAnalysisPrompt(1);
              setDoAllInputsExist(true);
              setUserRequest(prompt1);
            }}
          >
            {prompt1}
          </li>
          <li
            onClick={() => {
              setRaceAnalysisPrompt(2);
              setDoAllInputsExist(true);
              setUserRequest(prompt2)
            }}
          >
            {prompt2}
          </li>
          <li
            onClick={() => {
              setRaceAnalysisPrompt(3);
            }}
          >
            Enter your own prompt
          </li>
        </ul>

        {/* perosnal prompt textarea */}
        <div
          className={
            raceAnalysisPrompt === 3 ? "prompt-input" : "prompt-input-hidden"
          }
        >
          <textarea
            className={
              promptInputError ? "prompt-input-error" : "prompt-input-text"
            }
            id={promptInputError ? "prompt-input-error" : "prompt-input-text"}
            placeholder="Enter Your Prompt Here..."
          />
          <button
            onClick={() => {
              let input = promptInputError
                ? document.getElementById("prompt-input-error")
                : document.getElementById("prompt-input-text");

              const inputValue = input.value;

              if (hasUserEnteredAnything(inputValue) === true) {
                setDoAllInputsExist(true);
                setUserRequest(inputValue)
              } else {
                setDoAllInputsExist(false);
                setPromptInputError(true);
              }
            }}
          >
            Ask AI
          </button>
          <button
            onClick={() => {
              setRaceAnalysisPrompt(1);
              setDoAllInputsExist(false);
            }}
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
};

export const LapAnalysis = ({
  analysisType,
  setDoAllInputsExist,
  promptInputError,
  setPromptInputError,
  setChatGPTResponse
}) => {
  const [lapAnalysisPrompt, setLapAnalysisPrompt] = useState();
  const [previousCallsUntrimmed, setPreviousCallsUntrimmed] = useState([]); 
  const [previousCallsTrimmed, setPreviousCallsTrimmed] = useState([]); 
  const [currentActiveDropdown, setCurrentActiveDropdown] = useState([])
  const [prompt1, setPrompt1] = useState('')
  const [prompt2, setPrompt2] = useState('')
  const [userRequest, setUserRequest] = useState(''); 


  useEffect(() => {
    // Make a API call to get the dropdowns from the user when backend has started
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/coach/get-previous-calls?UserID=${JSON.parse(localStorage.getItem("sb_id"))?.id}&figureName=${analysisType}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((res) => res.json())
    .then((res) => {
      console.log(res.message)
      res.message.length > 0 ? setPreviousCallsUntrimmed(removeDuplicateCalls(res.message)): setPreviousCallsUntrimmed([]); 
    })
    .catch((error => {
      console.log(error)
    })); 
  }, [analysisType])

  useEffect(() => {
    setPreviousCallsUntrimmed([]);
    setPreviousCallsTrimmed([])
  }, [analysisType])

  useEffect(() => {
    setPreviousCallsTrimmed(trimDriverList(previousCallsUntrimmed)); 
  }, [previousCallsUntrimmed])

  console.log(currentActiveDropdown)

  useEffect(() => {
    console.log(!currentActiveDropdown)
    if (!currentActiveDropdown || currentActiveDropdown === false) {
      return;
    }

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/coach/make-driver-prompts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'         
      },
      body: JSON.stringify({
        promptContext: currentActiveDropdown,
        session: 'Qualifying'
      })    
    })
    .then((res) => res.json())
    .then((res) => {
      console.log(res)
      setLapAnalysisPrompt(res.message); 
      setPrompt1(res.message.prompt1); 
      setPrompt2(res.message.prompt2); 
    })
    .catch((error) => {
      console.error(error)
    })

  }, [currentActiveDropdown])

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/coach/pre-made-prompt-request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        raceResult: currentActiveDropdown,
        userRequest: userRequest
      })
    })
    .then((res) => res.json())
    .then((res) => {
      setChatGPTResponse(res.message)
    })
    .catch((error) => console.error(error))
  }, [userRequest])

  const removeDuplicateCalls = (
    prevFigRequests
  ) => {
    const uniqueSet = new Set();
    const deduplicated = [];

    for (const item of prevFigRequests) {
      const year = item.year;
      const circuit = item.circuit.trim().toLowerCase();

      // Defensive handling: ensure drivers is an array
      const driversArray = Array.isArray(item.drivers)
        ? [...item.drivers]
        : [String(item.drivers)];

      const sortedDrivers = driversArray.map(d => d.trim().toLowerCase()).sort();
      const key = `${year}|${circuit}|${sortedDrivers.join(',')}`;

      if (!uniqueSet.has(key)) {
        uniqueSet.add(key);
        deduplicated.push(item);
      }
    }
    
    return deduplicated; 
  }

    // STEP 2: Format display values
  const trimDriverList = (
    deduplicated
  ) => {
    const displayList = deduplicated.map(item => {
      const drivers = Array.isArray(item.drivers)
        ? item.drivers.join(', ')
        : item.drivers;

      const trimmedDrivers = drivers.length > 50 ? (
        drivers.slice(0, 75).trim() + '...'
      ) : (
        drivers
      )

      return trimmedDrivers ? `${item.year} | ${item.circuit} | ${trimmedDrivers}`: `${item.year} | ${item.circuit}`;
    });

    return displayList; 
  }

  return (
    <div className="analysis-container">
      <div className="upload-laps-container">
        <h2>Previous calls for {analysisType}</h2>
        <select className="upload-lap" name="upload-lap" id="upload-lap" onChange={(e) => setCurrentActiveDropdown(previousCallsUntrimmed[e.target.value])}>
            {Array.isArray(previousCallsTrimmed) && previousCallsTrimmed.map((item, idx) => (
              <option key={idx} value={idx}>
                {item}
              </option>
            ))}
        </select>
      </div>

      <div className="prompt-container">
        {/* If the prompt is set to the personal one, hide the other pre-made prompts */}
        <ul
          className={
            lapAnalysisPrompt === 3 ? "prompt-list-hidden" : "prompt-list"
          }
        >
          <li
            onClick={() => {
              setLapAnalysisPrompt(1);
              setDoAllInputsExist(true);
              setUserRequest(prompt1);
            }}
          >
            {prompt1}
          </li>
          <li
            onClick={() => {
              setLapAnalysisPrompt(2);
              setDoAllInputsExist(true);
              setUserRequest(prompt2);
            }}
          >
            {prompt2}
          </li>
          <li
            onClick={() => {
              setLapAnalysisPrompt(3);
            }}
          >
            Enter your own prompt
          </li>
        </ul>

        <div
          className={
            lapAnalysisPrompt === 3 ? "prompt-input" : "prompt-input-hidden"
          }
        >
          <textarea
            className={
              promptInputError ? "prompt-input-error" : "prompt-input-text"
            }
            id={promptInputError ? "prompt-input-error" : "prompt-input-text"}
            placeholder="Enter Your Prompt Here..."
          />
          <button
            onClick={() => {
              let input = promptInputError
                ? document.getElementById("prompt-input-error")
                : document.getElementById("prompt-input-text");

              const inputValue = input.value;

              if (hasUserEnteredAnything(inputValue) === true) {
                setDoAllInputsExist(true);
                setUserRequest(inputValue)
              } else {
                setDoAllInputsExist(false);
                setPromptInputError(true);
              }
            }}
          >
            Ask AI
          </button>
          <button
            onClick={() => {
              setLapAnalysisPrompt(1);
              setDoAllInputsExist(false);
            }}
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
};
